import React, { useState, useEffect } from "react";
import { getterms } from '../action/user';

function Cancellation() {
    useEffect(() => {
        // If you want to fetch additional content, add here
    }, []);

    return (
        <div className="container static-page">
            <div className="content">
                <h2>Cancellation and Refund Policy</h2>

                <h3 style={{fontSize:"25px", color: "#B21919"}}>1. Introduction</h3>
                <p>
                    This Cancellation and Refund Policy explains how members can cancel their membership or other paid services on Kalyana Sapthapadhi, and under what conditions a refund may be issued.
                    By purchasing any paid plan or premium feature on our Platform, you acknowledge that you have read, understood, and agree to the terms of this Policy.
                </p>

                <h3 style={{fontSize:"25px", color: "#B21919"}}>2. Nature of Services</h3>
                <p>
                    Kalyana Sapthapadhi provides personalized matrimonial matchmaking services through its online platform.
                    Since our offerings are digital and service-based, activation of a paid membership begins immediately after successful payment and confirmation.
                </p>

                <h3 style={{fontSize:"25px", color: "#B21919"}}>3. Membership Cancellation</h3>
                <h4>3.1 Voluntary Cancellation by the Member</h4>
                <p>
                    You may cancel your free or paid membership at any time by logging into your account and using the “Delete Account” or “Cancel Membership” option, or by writing to <a href="mailto:support@kalyanasapthapadhi.com">support@kalyanasapthapadhi.com</a>.
                    Upon cancellation, your profile will be deactivated and made invisible to other members.<br />
                    For verification and record purposes, Kalyana Sapthapadhi may retain limited transactional data in accordance with our Privacy Policy.
                </p>

                <h4>3.2 Cancellation by Kalyana Sapthapadhi</h4>
                <p>
                    Lycoris Pvt. Ltd. reserves the right to suspend or terminate any account that violates our Terms of Use, involves fraudulent activity, or misuses the Platform.
                    Such cancellations will not be eligible for any refund.
                </p>

                <h3 style={{fontSize:"25px", color: "#B21919"}}>4. Refund Eligibility</h3>
                <table className="cd-pricing-list" style={{marginBottom:"24px", width:"100%", borderCollapse: "collapse", fontSize: "16px"}}>
                    <thead>
                        <tr style={{background: "#f7f7f7"}}>
                            <th style={{padding: "10px", border: "1px solid #eaeaea"}}>Situation</th>
                            <th style={{padding: "10px", border: "1px solid #eaeaea"}}>Refund Eligibility</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{padding: "10px", border: "1px solid #eaeaea"}}>Duplicate payment due to technical error</td>
                            <td style={{padding: "10px", border: "1px solid #eaeaea"}}>100% refund of the duplicate amount</td>
                        </tr>
                        <tr>
                            <td style={{padding: "10px", border: "1px solid #eaeaea"}}>Payment deducted but service not activated</td>
                            <td style={{padding: "10px", border: "1px solid #eaeaea"}}>Full refund after verification</td>
                        </tr>
                        <tr>
                            <td style={{padding: "10px", border: "1px solid #eaeaea"}}>Accidental subscription upgrade (reported within 24 hours)</td>
                            <td style={{padding: "10px", border: "1px solid #eaeaea"}}>75% refund after service verification</td>
                        </tr>
                        <tr>
                            <td style={{padding: "10px", border: "1px solid #eaeaea"}}>Service dissatisfaction or change of mind</td>
                            <td style={{padding: "10px", border: "1px solid #eaeaea"}}>Not eligible</td>
                        </tr>
                        <tr>
                            <td style={{padding: "10px", border: "1px solid #eaeaea"}}>Account terminated for policy violation</td>
                            <td style={{padding: "10px", border: "1px solid #eaeaea"}}>Not eligible</td>
                        </tr>
                    </tbody>
                </table>
                <p>Note: All approved refunds will be processed to the original payment method used during purchase.</p>

                <h3 style={{fontSize:"25px", color: "#B21919"}}>5. Refund Request Process</h3>
                <ol>
                    <li>Send an email to <a href="mailto:billing@kalyanasapthapadhi.com">billing@kalyanasapthapadhi.com</a> with: Registered name and phone number, Transaction ID/payment receipt, Reason for cancellation or refund request.</li>
                    <li>Our Billing Team will review your request within 5–7 business days.</li>
                    <li>If approved, refunds will be initiated within 10–15 working days depending on your bank or payment gateway.</li>
                </ol>

                <h3 style={{fontSize:"25px", color: "#B21919"}}>6. Non-Refundable Services</h3>
                <ul>
                    <li>Any portion of a membership plan already used</li>
                    <li>Profile enhancement, spotlight, or promotional credits</li>
                    <li>Value-added services (e.g., horoscope matching, verification badges, or video introduction uploads)</li>
                    <li>Taxes, payment gateway charges, or processing fees</li>
                </ul>

                <h3 style={{fontSize:"25px", color: "#B21919"}}>7. Force Majeure</h3>
                <p>No refunds shall be made for interruptions caused by events beyond our reasonable control, such as natural disasters, internet outages, regulatory restrictions, or cyber-attacks.</p>

                <h3 style={{fontSize:"25px", color: "#B21919"}}>8. Contact for Cancellations and Refunds</h3>
                <p>
                    Billing & Refund Desk – Kalyana Sapthapadhi<br />
                    Lycoris Pvt. Ltd.<br />
                    <a href="mailto:billing@kalyanasapthapadhi.com">billing@kalyanasapthapadhi.com</a><br />
                    Customer Care: [Insert Helpline Number]<br />
                    Hours: Monday – Saturday, 10 AM to 6 PM (IST)
                </p>

                <h3 style={{fontSize:"25px", color: "#B21919"}}>9. Policy Amendments</h3>
                <p>
                    Lycoris Pvt. Ltd. may modify or update this Cancellation and Refund Policy at any time to reflect operational or legal requirements.
                    The most current version will always be available on our website under Legal Policies.
                </p>
            </div>
        </div>
    );
}

export default Cancellation;
